/** Decode JSON from storage or transport, using the caller's fallback for missing or malformed values. */
export function parseJsonOr<T>(value: unknown, fallback: T): T {
  if (typeof value !== 'string') return fallback;
  try {
    return JSON.parse(value) as T;
  } catch {
    return fallback;
  }
}
